import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import {
  Wrapper,
  WrapperStd,
  Title,
  Text,
  SponsorList,
  SponsorLink,
} from './elements';
import { useText } from 'common/hooks';
import { getOrderedSponsors } from 'utils/challenge';

const deps = {
  campaign: state.challenge.campaign,
};

function MoreInfo({
  campaign,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const [orderedSponsors, setOrderedSponsors] = useState([]);

  useEffect(() => {
    setOrderedSponsors(getOrderedSponsors(campaign.sponsors));
  }, [campaign.sponsors]);

  return (
    <Wrapper>
      <WrapperStd>
        <Title>
          {t(`challenge.ChaPaD10A.ChaSec02.details_${campaign?.topic}`)}
        </Title>
        <Text>{t.markdown(campaign?.description)}</Text>
        {orderedSponsors.length > 0 ? (
          <>
            <Title>{t('challenge.ChaPaD10A.ChaSec02.presented_by')}</Title>
            <SponsorList>
              {orderedSponsors.map(sponsor => (
                <li key={sponsor.id}>
                  <SponsorLink href={sponsor.url}>
                    {t.markdown(sponsor.name)}
                  </SponsorLink>
                </li>
              ))}
            </SponsorList>
          </>
        ) : null}
        <Title>{t('challenge.ChaPaD10A.ChaSec02.prize')}</Title>
        <Text>{t.markdown(campaign?.challenge?.prize)}</Text>
      </WrapperStd>
    </Wrapper>
  );
}

export default connect(deps, MoreInfo);
